import * as _ from 'lodash';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SharedHttpClientService } from '../../../Shared/Services/shared-http-client.service';
import { UrlsService } from '../../../Shared/Services/urls.service';
import { HttpErrorResponse } from '@angular/common/http';
import { APIURL } from '../../../Shared/Constant/API_Urls';
import { GridService } from '../../../Shared/Services/grid.service';
import { UserService } from '../../../Shared/Services/user.service';
import {default as GridColumnsJSON} from './CAIS-Exception-Grid-Columns.json';
import { EmitterService } from 'app/Shared/Services/emitter.service';
import { map, Subscription } from 'rxjs';
import { ConstantService } from 'app/Shared/Services/constant-service';
import { Table, TableModule  } from "primeng/table";
import { generateCsv, asBlob } from "export-to-csv";
import { saveAs } from 'file-saver';
import { MessageService,ConfirmationService } from 'primeng/api';
import { DataService } from 'app/Shared/Services/data.service';
import { SortPipe } from 'app/Shared/Component/pipes/sort.pipe';
import { CaisExceptionServiceService } from './cais-exception-service.service';
import { CaisServiceService } from '../cais-service.service';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ButtonModule } from 'primeng/button';
import { FilterPanelComponent } from 'app/Shared/Component/filter-panel/filter-panel.component';
import { LowerCasePipe, NgClass, CommonModule } from '@angular/common';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { ExportToCSVSComponent } from 'app/Shared/Component/export-to-csv/export-to-csv.component';
import { SymbolPanelComponent } from 'app/Shared/Component/symbol-panel/symbol-panel.component';
import { ViewComponent } from '../shared-component/view/view.component';
import { EditComponent } from '../shared-component/edit/edit.component';
import { CAISAuditTrailDialogComponent } from '../shared-component/cais-audit-trail/cais-audit-trail-dialog.component';
import { ToastModule } from 'primeng/toast';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
    selector: 'app-exceptions',
    imports: [FilterPanelComponent, ButtonModule, NgClass, CommonModule, TableModule,
        MatProgressSpinner, ExportToCSVSComponent, LowerCasePipe, ConfirmDialogModule, SymbolPanelComponent, ViewComponent,
        CAISAuditTrailDialogComponent, ToastModule, MatTooltipModule, EditComponent],
    templateUrl: './exceptions.component.html',
    styleUrls: ['./exceptions.component.scss']
})
export class ExceptionsComponent implements OnInit {

  @ViewChild(('dt')) dt!: Table;
  GridColumns = GridColumnsJSON["ExceptionCols"];
  CAISExceptionCSVGridColumns: any;
  ActiveExceptionCode: any = '';
  dataset: any[] = [];
  ApplicationName: any = '';
  activeRecordType: any = 'FINRA';
  screenType = " Exception"
  ResetLabel: string = "";

  LastExecutionDate!: any[];
  recordTypeArray: any = [{
    "label": "FINRA",
    "value": "FINRA"
  },
  {
    "label": "CLIENT",
    "value": "CLIENT"
  }];

  statusDropDown:any =  [{
    "label": "OPEN",
    "value": "OPEN"
  },
  {
    "label": "CORRECTED",
    "value": "CORRECTED"
  },
  {
    "label": "CLOSED",
    "value": "CLOSED"
  }];

  quickFilterEntityType: any;
  quickFilterEntityTypeArray: any =
    [{
      "label": "FDID",
      "value": "FDID"
    },
    {
      "label": "Supplement",
      "value": "Supplement"
    }, {
      "label": "LTID",
      "value": "LTID"
    },
    {
      "label": "Entity",
      "value": "Entity"
    }, {
      "label": "Person",
      "value": "Person"
    },
    {
      "label": "TID",
      "value": "TID"
    }];
  quickFilterDate: any;
  quickFilterDateArray: any = [];
  DefaultFilterArray: any = [];
  isLoadingResults = true;
  Limit: any = { 'Start': '', 'End': '' };
  previousLimit: any = { 'Start': '', 'End': '' };
  rowsPerPageOptions: any = [];
  totalRecords!: number;
  rowcount!: number;
  startLimit: any = 0;
  endLimit!: number;
  tbldatamsg = 'L o a d i n g . . . . .';
  cols: any = []
  filterCols: any = [];
  selectedRow: any = [];
  pageNumber: any = 1;
  priviousStartLimit: any;
  rowDataforDialog: any = [];
  rowIndexForDialog!: number;
  actionType!: string;
  subscription!: Subscription;
  sortData: any = { field: '', order: 0 };
  sortClickCounter: number = 0;
  defaultData: any;
  codesArray: any = [];
  isAuditTrail!: boolean;

  constructor(private userService: UserService,
    private urlService: UrlsService,
    private gridService: GridService,
    private messageService: MessageService,

    public confirmationService: ConfirmationService,
    public constantService: ConstantService,
    public dataService: DataService,
    private emitterService: EmitterService,
    private sortPipe: SortPipe,
    private activatedRoute: ActivatedRoute,
    private sharedHttpClientService: SharedHttpClientService,
    public caisExceptionServiceService: CaisExceptionServiceService,
    public caisServiceService: CaisServiceService,
  ) {
    this.cols = [];
    this.filterCols = [];
    this.ApplicationName = this.constantService.getApplicationName();
  }

  ngOnInit(): void {
    this.rowcount = this.constantService.DEFAULT_ROWSIZE;
    this.endLimit = this.constantService.DEFAULT_ROWSIZE;
    this.caisExceptionServiceService.isCaisView = false;
    this.caisExceptionServiceService.isCaisEdit = false;
    this.Limit = { 'Start': '0', 'End': this.rowcount };
    this.userService.caisExceptionType = this.activeRecordType;
    this.rowsPerPageOptions = this.constantService.DEFAULT_ROWSPERPAGEOPTION;
    this.dataset = [];
    this.totalRecords = this.rowcount;
    this.getColumns();
    this.getReportDateList();
    this.defaultFilter();
    this.subscription = this.emitterService.reloadMainDashBoard.subscribe({
      next: (value:any) => {
      if (value) {
        this.getReportDateList();
        this.getData();
        this.getErrorCode();
      }
    }});
  }

  getColumns() {
    let csvGridColumns = this.GridColumns;
    this.CAISExceptionCSVGridColumns = csvGridColumns.filter((gridColObj: any) => !gridColObj?.isOptionalFields && /^true$/i.test(gridColObj?.display) && !_.includes(['Action'], gridColObj?.ui_columnname)); // Receiving Only Mandatory Fields and Ignoring Optional Fields

    let column: any;
    column = this.GridColumns;
    if (column !== null || column !== undefined) {
      this.cols = this.gridService.getGridColumns(column);
      this.filterCols = this.cols;
    }
  }

  onRowSelect(action: any, index?: any, rowData?: Object) {
    this.caisExceptionServiceService.isCaisView = false;
    this.caisExceptionServiceService.isCaisEdit = false;
    this.actionType = action;
    this.caisServiceService.actionType = action;
    this.dataService.roeSelectedRecords = [];
    this.dataService.roeSelectedRecords[0] = (rowData);
    this.rowDataforDialog = rowData
    this.caisExceptionServiceService.rowDataforDialog = rowData;
    this.rowIndexForDialog = index;
    if (action === 'View') {
      this.caisExceptionServiceService.isCaisView = true;
    } else if (action === 'Edit') {
      this.caisExceptionServiceService.isCaisEdit = true;
    } else if (action == 'AuditTrail') {
      this.isAuditTrail = true;
      this.dataService.roeSelectedRecords[0] = (rowData);
      this.rowDataforDialog = rowData;
    }else if (action === 'DELETE') {
      this.onDelete(index,rowData);
    }else if (action === 'RESTOREDELETED') {
      this.onRestoreDeleted(index,rowData);
    }
  }

  FilterApplyFilterEvent(event: any) {
    this.emitterService.isResetGridLimit.emit(true);
    this.DefaultFilterArray = [];
    this.DefaultFilterArray = event;
    this.startLimit = 0;
    this.Limit.Start = 0;
    this.Limit.End = this.rowcount;
    this.dt.first = 0; // Reset PaneNum in PageLinks
    let recordTypeIndex = this.DefaultFilterArray.findIndex((filterElem: { label: string; }) => filterElem.label === 'Source');
    this.activeRecordType = this.DefaultFilterArray[recordTypeIndex].values;
    let entityTypeIndex = this.DefaultFilterArray.findIndex((filterElem: { label: string; }) => filterElem.label === 'Entity');
    this.quickFilterEntityType = this.DefaultFilterArray[entityTypeIndex].values;
    let dateIndex = this.DefaultFilterArray.findIndex((filterElem: { label: string; }) => filterElem.label === 'Report Date');
    if(this.DefaultFilterArray[dateIndex].values == ''){
      this.quickFilterDate = '';
    }
    this.DefaultFilterArray = [...this.DefaultFilterArray];
    this.getData();
    this.getErrorCode();
  }

  setActiveCodeEvent(event: any) {
    let activeCode: number = event;
    let index = this.DefaultFilterArray.findIndex((filterElem: { label: string; }) => filterElem.label === 'Error Code');
    this.DefaultFilterArray[index].values = activeCode;
    this.FilterApplyFilterEvent(this.DefaultFilterArray);
  }


  FilterEventClearCode(event: any) {
    this.emitterService.ResetQuickFilterPanelEvent.emit("Code");
  }

  getErrorCode() {
    const filterData = this.DefaultFilterArray.filter((filterElem: { label: string; }) => filterElem.label !== 'Error Code');
    this.gridService.getSymbol(APIURL.QuickFilterFields, filterData, this.Limit, "CAIS-Exception")
      .subscribe({
        next: (element:any) => {
        let Filter: any = element;
        this.codesArray = [];
        this.codesArray = Filter.CodeList;
      }, error: (err: HttpErrorResponse) => {
      }});
  }

  applyEntityFilter(entity: any) {
    let entityTypeIndex = this.DefaultFilterArray.findIndex((filterElem: { label: string; }) => filterElem.label === 'Entity');
    this.DefaultFilterArray[entityTypeIndex].values = entity;
    this.quickFilterEntityType = entity;
    this.FilterApplyFilterEvent(this.DefaultFilterArray);
  }

  applyDateFilter(reportDate: any) {
    let entityTypeIndex = this.DefaultFilterArray.findIndex((filterElem: { label: string; }) => filterElem.label === 'Report Date');
    this.DefaultFilterArray[entityTypeIndex].values = [reportDate, reportDate];
    this.quickFilterDate = reportDate;
    this.FilterApplyFilterEvent(this.DefaultFilterArray);
  }

  GridChangeLimitEvent(event: any) {
    this.Limit = event;
    this.getData();
  }

  checkFailureCode(code: any) {
    return (code < 21001 || code > 21021) && (code < 21501 || code > 21519)
  }

  skipEditActionFailureCode(code: any) {
    return !"22048".includes(code);
  }



  checkFailureCodeForDelete(code: any) {
    return (code > 22001 ||  code < 23999 );
  }

  defaultFilter() {
    this.DefaultFilterArray = [
      { 'isdefault': 'true', 'label': 'Report Date', 'columnname': 'reportDate', 'filterby': 'IS', 'values': '', 'time': '', 'datatype': 'DateRange', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': '' },
      {
        'isdefault': 'true', 'label': 'Source', 'columnname': 'source', 'filterby': 'IS', 'values': this.activeRecordType, 'time': '', 'datatype': 'String', 'disabled': 'false', 'dropdown': 'YES', "dropdowntype": "singleselect", 'dropdownvalue': this.recordTypeArray
      },
      {
        'isdefault': 'true', 'label': 'Status', 'columnname': 'status', 'filterby': 'IS', 'values':'', 'time': '', 'datatype': 'String', 'disabled': 'false', 'dropdown': 'YES', "dropdowntype": "singleselect", 'dropdownvalue': this.statusDropDown
      },
      {
        'isdefault': 'true', 'label': 'Entity', 'columnname': 'fileType', 'filterby': 'IS', 'values': this.quickFilterEntityType, 'time': '', 'datatype': 'String', 'disabled': 'true', 'dropdown': 'YES', "dropdowntype": "singleselect", 'dropdownvalue': this.quickFilterEntityTypeArray
      },
      { 'isdefault': 'true', 'label': 'Error Code', 'columnname': 'failureCode', 'filterby': 'IS', 'values': (this.activatedRoute.snapshot.paramMap.get('Code') ? this.activatedRoute.snapshot.paramMap.get('Code') : ''), 'time': '', 'datatype': 'String', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': '' },
      { 'isdefault': 'true', 'label': 'Customer Record ID', 'columnname': 'customerRecordID', 'filterby': 'IS', 'values': '', 'time': '', 'datatype': 'String', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': '' },
      { 'isdefault': 'true', 'label': 'In Customer Record ID', 'columnname': 'inCustomerRecordID', 'filterby': 'IS', 'values': '', 'time': '', 'datatype': 'String', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': '' },
      { 'isdefault': 'true', 'label': 'FirmDesignatedID', 'columnname': 'firmDesignatedID', 'filterby': 'IS', 'values': '', 'time': '', 'datatype': 'String', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': '' },
      { 'isdefault': 'true', 'label': 'Account Type', 'columnname': 'accountType', 'filterby': 'IS', 'values': '', 'time': '', 'datatype': 'String', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': '' },
    ];
    this.getErrorCode();
    /* Set Exception Code in Default Page Filter */
    if (this.activatedRoute.snapshot.paramMap.get('Code')) {
      this.ActiveExceptionCode = this.activatedRoute.snapshot.paramMap.get('Code');
      this.setActiveCodeEvent(this.activatedRoute.snapshot.paramMap.get('Code'));
    } else {
      this.getData();
    }
    
  }

  getRecordTypeData(recordType: any) {
    this.activeRecordType = recordType;
    this.userService.caisExceptionType = recordType;
    let recordTypeIndex = this.DefaultFilterArray.findIndex((filterElem: { label: string; }) => filterElem.label === 'Source');
    this.DefaultFilterArray[recordTypeIndex].values = recordType;
    let entityTypeIndex = this.DefaultFilterArray.findIndex((filterElem: { label: string; }) => filterElem.label === 'Report Date');
    this.DefaultFilterArray[entityTypeIndex].values = '';
    this.quickFilterDate = '';
    this.DefaultFilterArray = [...this.DefaultFilterArray];
    this.getReportDateList();
    this.FilterApplyFilterEvent(this.DefaultFilterArray);

  }

  changePage(event: { first: any; rows: number; }) {
    this.startLimit = event.first;
    this.endLimit = this.startLimit + this.rowcount;
    this.rowcount = event.rows;
    if (this.endLimit > this.totalRecords) {
      this.endLimit = this.totalRecords;
    }
    this.Limit = { 'Start': this.startLimit, 'End': this.rowcount };
    this.priviousStartLimit = this.startLimit;
    this.pageNumber = Math.round(this.startLimit / this.rowcount) + 1;
    this.getData();
  }

  getData() {
    this.dataService.roeSelectedRecords = [];
    this.dataset = [];
    this.isLoadingResults = true;
    this.Limit = { 'Start': this.startLimit, 'End': this.rowcount };
    this.previousLimit = this.Limit;
    this.tbldatamsg = 'L o a d i n g . . . . .';

    const filterData = JSON.parse(JSON.stringify(this.DefaultFilterArray));
    if (filterData[0].values.length === 2) {
      filterData[0].values[0] = this.userService.getyyyyMMddDateFormate(JSON.parse(JSON.stringify(filterData[0].values[0])));
      filterData[0].values[1] = this.userService.getyyyyMMddDateFormate(JSON.parse(JSON.stringify(filterData[0].values[1])));
    }

    this.sharedHttpClientService.post(
      this.urlService.setAPIURl(
        APIURL.CAIS_Exception
      ), {
      CATReporterIMID: this.userService.getActiveMPID(),
      user: this.userService.getUserName(),
      userName: this.userService.getUserFirstName(),
      data: filterData,
      startLimit: this.Limit.Start.toString(),
      endLimit: this.Limit.End.toString()
    }
    ).subscribe({
      next: (element:any) => {
      let dataset: any = element;
      this.dataset = dataset.Data;
      this.defaultData = this.dataset;
      this.dataset = _.orderBy(_.sortBy(this.dataset, this.sortData.field), [this.sortData.field], [this.sortData.order]);
      this.totalRecords = dataset.totalCount;
      this.totalRecords = this.gridService.handleNoRecordsPageNumber(this.totalRecords);
      if (this.dataset.length == 0) {
        this.tbldatamsg = "No data found";
      }
      this.isLoadingResults = false;
    }, error: (err: HttpErrorResponse) => {
      this.isLoadingResults = false;
    }});
  }

  getReportDateList() {
    this.sharedHttpClientService.post(
      this.urlService.setAPIURl(
        APIURL.CAIS_Exception_ReportDateList
      ), {
      CATReporterIMID: this.userService.getActiveMPID(),
      activeRecordType: this.activeRecordType,
      user: this.userService.getUserName(),
      userName: this.userService.getUserFirstName(),
    }
    ).subscribe({
      next: (element:any) => {
      let dataset: any = element;
      this.quickFilterDateArray = dataset.reportDateList;
    }, error: (err: HttpErrorResponse) => {
    }});
  }

  exportToCSV(event: any) {
    let initialTime = new Date().toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', second: '2-digit' });
    // to let user know the button is clicked and download process is started
    this.messageService.add({ severity: 'info', summary: 'File', detail: 'Please wait.. Preparing export file to download..' });

    if (event.isExportMaxRows) {
      this.Limit = { 'Start': this.constantService.NUMBER_0, 'End': this.constantService.NUMBER_MAX_EXPORT_ROWS };
    } else {
      this.Limit = this.previousLimit;
    }

    const filterData = JSON.parse(JSON.stringify(this.DefaultFilterArray));
    if (filterData[0].values.length === 2) {
      filterData[0].values[0] = this.userService.getyyyyMMddDateFormate(JSON.parse(JSON.stringify(filterData[0].values[0])));
      filterData[0].values[1] = this.userService.getyyyyMMddDateFormate(JSON.parse(JSON.stringify(filterData[0].values[1])));
    }

    const exportCSVPayload = {
      "CATReporterIMID": this.userService.getActiveMPID(),
      "user": this.userService.getUserName(),
      "userName": this.userService.getUserFirstName(),
      "data": JSON.parse(JSON.stringify(filterData)),
      "startLimit": this.Limit.Start + "",
      "endLimit": this.Limit.End + "",
      "pageName": 'CAIS-Exception'
    };

    this.sharedHttpClientService.post(
      this.urlService.setAPIURl(APIURL.CAIS_Exception),
      exportCSVPayload
    ).pipe(map((response: Response) => {
      return response;
    })).subscribe({
      next: (element:any) => {
      this.isLoadingResults = false;

      let dataset: any = element;
      let data = dataset.Data;

      if (data.length > 0) {
        const options: any = {
          fieldSeparator: ',',
          quoteStrings: '"',
          decimalSeparator: '.',
          showLabels: true,
          showTitle: true,
          title: 'RSMS_CAIS_Exception_' + this.userService.getyyyyMMddDateFormate(new Date()),
          useTextFile: false,
          useBom: true,
          useKeysAsHeaders: true,
          // header: ['col 1', 'col 2'] // Won't work with useKeysAsHeaders present!
          filename: this.userService.getActiveMPID() + '_RSMS_CAIS_Exception_' + this.userService.getyyyyMMdd_HH_MM_SSDateFormate(new Date()),
        };
        let csvGridColumns = event.gridColumn.filter((gridColObj: any) => !gridColObj?.isOptionalFields); // Receiving Only Mandatory Fields and Ignoring Optional Fields
        const csvData = this.constantService.getExportData(data, csvGridColumns);
        const csv = generateCsv(options)(csvData);
        const blob = asBlob(options)(csv);
        saveAs(blob,options.filename);

        this.messageService.add({ severity: 'success', summary: 'File', detail: 'File Download Successfully' });
        this.userService.logUserActivity('Export CSV', null, {
          'Text1': 'File Download Successfully | ' + (data.length > 0 ? data.length : 0) + ' records downloaded with file name: ' + options.filename + ' with start time: ' + initialTime + ' and end time: ' + new Date().toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', second: '2-digit' }),
          'Text2': 'User Filter Parameters: ' + JSON.stringify(filterData.filter((filterParam: { values: string | any[]; }) => (filterParam.values != '' || filterParam.values.length > 0)))
        });
      } else {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'No data found' });
        this.userService.logUserActivity('Export CSV', null, {
          'Text1': 'No data found',
          'Text2': 'User Filter Parameters: ' + JSON.stringify(filterData.filter((filterParam: { values: string | any[]; }) => (filterParam.values != '' || filterParam.values.length > 0)))
        });
      }
      this.emitterService.exportToCSVData.emit(true);
    }, error: (err: HttpErrorResponse) => {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error while Exporting' });
      this.userService.logUserActivity('Export CSV', null, {
        'Text1': 'Error while Exporting',
        'Text2': 'User Filter Parameters: ' + JSON.stringify(filterData.filter((filterParam: { values: string | any[]; }) => (filterParam.values != '' || filterParam.values.length > 0)))
      });
    }});
  }

  sort(event: any) {
    if (this.sortClickCounter !== 3 && (this.sortData.field === "" || this.sortData.field === event.multisortmeta[0].field)) {
      this.sortClickCounter = this.sortClickCounter + 1;
    } else {
      this.sortClickCounter = 1;
    }
    if (this.sortClickCounter !== 3) {
      let sortOrder = event.multisortmeta[0].order === 1 ? 'asc' : 'desc';
      this.sortData.field = event.multisortmeta[0].field;
      this.sortData.order = sortOrder;
      this.dataset = this.sortPipe.transform(this.dataset, this.sortData.order, this.sortData.field);
    } else {
      this.resetSort()
    }

  }

  resetSort() {
    if(this.dt.multiSortMeta != undefined && this.dt.multiSortMeta?.length > 0) {
    this.dt.multiSortMeta[0].field = '';
    this.dt.multiSortMeta[0].order = 0;
    }

    this.dataset = this.defaultData;
  }

  onDelete(index?: any, rowData?: Object){
    let msg = '';
    if (this.dataService.roeSelectedRecords.length > 1)
      msg = 'Are you sure you want to remove all exceptions?';
    else{
      this.dataService.roeSelectedRecords[0]=rowData;
      msg = 'Are you sure you want to remove this exception?';
    }
    this.confirmationService.confirm({
      message: msg,
      icon: 'pi pi-exclamation-triangle',
      header: 'Confirmation',
      acceptLabel: 'Yes',
      acceptIcon:'pi pi-check',
      defaultFocus: 'reject',
      rejectLabel: 'No',
      rejectIcon:'pi pi-times',
      acceptButtonStyleClass:"confirm-dialog-button",
      rejectButtonStyleClass:"confirm-dialog-button",

      accept: () => {
        let dataList = this.preparePayload(this.dataService.roeSelectedRecords);
        this.caisExceptionServiceService.onDelete(index,dataList)
        .subscribe({
          next: (Element:any) => {
          this.messageService.add({ severity: 'success', summary: 'Delete Message', detail: 'Records are Deleted Successfully ' });
          this.getData(); 
        }, error: (err: HttpErrorResponse) => {
          this.isLoadingResults = false;
          this.messageService.add({ severity: 'error', summary: 'Delete Message', detail: 'Deleted Failed' });
        }});
      }
    });
  }

  onRestoreDeleted(index?: any, rowData?: Object){
    let msg = '';
    if (this.dataService.roeSelectedRecords.length > 1)
      msg = 'Are you sure that you want to Restore DELETED All?';
    else{
      this.dataService.roeSelectedRecords[0]=rowData;
      msg = 'Are you sure that you want to Restore DELETED?';
    }

    this.confirmationService.confirm({
      message: msg,
      accept: () => {
        let dataList = this.preparePayload(this.dataService.roeSelectedRecords);
        this.caisExceptionServiceService.onRestoreDeleted(index,dataList)
        .subscribe({
          next: (Element:any) => {
          this.messageService.add({ severity: 'success', summary: 'Delete Message', detail: 'Restored Successfully ' });
          this.getData();  
        }, error: (err: HttpErrorResponse) => {
          this.messageService.add({ severity: 'error', summary: 'Delete Message', detail: 'Restore Deleted Failed' });
          this.isLoadingResults = false;
        }});
      }
    });
  }

  ngOnDestroy() {
    if (this.subscription)
      this.subscription.unsubscribe();
  }

  preparePayload(roeSelectedRecords: any) {
    let payloadList:any = [];
    if(roeSelectedRecords){
      roeSelectedRecords.filter((row: { [x: string]: string; }) => {
       if(row['status'] != 'SUBMITTED'  && row['status'] != 'GENERATED')
        payloadList.push(row);
      });
    }
    this.dataService.roeSelectedRecords = payloadList;
    return payloadList;
    }
}



